jQuery(document).ready(function($) {
    $(document).on('gform_confirmation_loaded', function(event, formId) {
        if (formId === 27) {
            $('html, body').animate({ scrollTop: 0 }, 'fast');
        }
    });
});